export class CreateTariffModel {
  public tipoId = 0
  public origemId = 0
  public destinoId = 0
  public tipoServicoId = 0
  public servicoId = 0
  public tipoVeiculoId = 0
  public tipoMotoristaId = 0
  public clienteId = 0
  public fornecedorId = 0
  public custo = 0.0
  public custoHoraExtra = 0.0
  public custoKmExtra = 0.0
  public ativo = 'N'
  public dataValidade = ''
}

export class EditTariffModel {
  public id = 0
  public tipoId = 0
  public origemId = 0
  public destinoId = 0
  public tipoServicoId = 0
  public servicoId = 0
  public tipoVeiculoId = 0
  public tipoMotoristaId = 0
  public clienteId = 0
  public fornecedorId = 0
  public custo = 0
  public custoHoraExtra = 0
  public custoKmExtra = 0
  public ativo = 0
  public dataValidade = 0
}

export class DeleteTariffModel {
  public id = 0
  public descricao = ''
}

export class SearchTariffModel {
  public descricao = ''
}

export class CreateTariffResponse {
  public response: any
}
export class EditTariffResponse {
  public response: any
}
export class DeleteTariffResponse {
  public response: any
}
export class PagedTariffResponse {
  public response: any
}

export class ImportTariffModel {
  public TipoTarifario = 0
  public ClienteId = 0
  public ExcelFile: File | null = null

  public toFormData(): FormData {
    const formData = new FormData()

    formData.append('TipoTarifario', this.TipoTarifario.toString())
    formData.append('ClienteId', this.ClienteId.toString())

    if (this.ExcelFile) {
      formData.append('ExcelFile', this.ExcelFile)
    }

    return formData
  }
}

export class ImportTariffNewModel {
  public TipoTarifario = 0
  public ClienteId = 0
  public FornecedorId = 0
  public ExcelFile: File | null = null

  public toFormData(): FormData {
    const formData = new FormData()

    formData.append('TipoTarifario', this.TipoTarifario.toString())
    formData.append('ClienteId', this.ClienteId.toString())
    formData.append('FornecedorId', this.FornecedorId.toString())

    if (this.ExcelFile) {
      formData.append('ExcelFile', this.ExcelFile)
    }

    return formData
  }
}
